/**
 * Avatar Atom
 *
 * Avatar de usuário
 */
import React from 'react'
import { User } from 'lucide-react'
import { formatImageUrl } from '../../../../app/shared/utils/api'

const sizes = {
	sm: 'w-8 h-8 text-xs',
	md: 'w-10 h-10 text-sm',
	lg: 'w-12 h-12 text-base',
	xl: 'w-16 h-16 text-lg',
}

const iconSizes = {
	sm: 'w-4 h-4',
	md: 'w-5 h-5',
	lg: 'w-6 h-6',
	xl: 'w-8 h-8',
}

export default function Avatar({
	src,
	name,
	size = 'md',
	className = '',
}) {
	// Gerar iniciais do nome
	const initials = name
		?.split(' ')
		.map((n) => n[0])
		.join('')
		.substring(0, 2)
		.toUpperCase()

	// Formata a URL da imagem
	const imageUrl = formatImageUrl(src)

	if (imageUrl) {
		return (
			<img
				src={imageUrl}
				alt={name || 'Avatar'}
				className={`rounded-full object-cover ${sizes[size]} ${className}`}
				onError={(e) => {
					// Em caso de erro, esconde a imagem e mostra as iniciais
					e.target.style.display = 'none'
				}}
			/>
		)
	}

	return (
		<div
			className={`
        flex items-center justify-center rounded-full
        bg-primary-100 text-primary-700 font-medium
        ${sizes[size]} ${className}
      `}
		>
			{initials || <User className={iconSizes[size]} />}
		</div>
	)
}
